<template>
  <b-modal
    id="crearMovimientoModal"
    size="xl"
    :title="`Crear ${tipoMovimiento}`"
    :hide-footer="true"
    @hidden="borrarMovimiento"
    @shown="mostrarMovimiento"
  >
    <form @submit.prevent="submit" v-promise-btn="{ action: 'submit' }">
      <card-item>
        <template slot="header">
          <div class="d-flex justify-content-center align-items-center">
            <h4 class="card-title">Crear {{ tipoMovimiento }}</h4>
          </div>
        </template>

        <div class="container">
          <div class="row">
            <div class="col-12 form-group form-sm-group">
              <label for="fecha" class="label">Fecha</label>
              <input
                type="datetime-local"
                :class="`form-control form-control-sm text-center bg-white${
                  !isFechaOk && isDirty ? ' is-invalid' : ''
                }`"
                style="cursor: text"
                v-model="fecha"
                id="fecha"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 form-group form-sm-group">
              <label for="monto" class="label">{{ tipoMovimiento }}</label>
              <vue-numeric
                v-select-on-focus
                thousand-separator="."
                decimal-separator=","
                :precision="2"
                id="monto"
                v-model="monto"
                :minus="true"
                :class="`col-12 form-control form-control-sm text-center bg-white${
                  !isMontoOk && isDirty ? ' is-invalid' : ''
                }`"
              ></vue-numeric>
            </div>

            <div class="col-12 col-md-6 form-group form-sm-group">
              <label class="label">Moneda</label>
              <select class="form-control" v-model="moneda">
                <option value="Pesos">Pesos</option>
                <option value="Dolar">Dolares</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 form-group form-sm-group">
              <label class="typo__label">Concepto</label>
              <multiselect-item
                v-model="movimientoConcepto"
                :loading="isMovimientoConceptoLoading"
                deselect-label="Deseleccionar"
                track-by="id_movim_concepto"
                label="concepto"
                placeholder="Seleccionar concepto"
                :options="movimientoConceptos"
                :searchable="true"
                :allow-empty="true"
              >
              </multiselect-item>
            </div>

            <div
              class="col-12 col-md-6 form-group form-sm-group"
              v-if="movimientoConcepto"
            >
              <label class="typo__label">Concepto Item</label>
              <multiselect-item
                v-model="movimientoConceptoItem"
                deselect-label="Deseleccionar"
                track-by="id_movim_concepto_items"
                label="item"
                placeholder="Seleccionar concepto"
                :options="movimientoConcepto.items"
                :searchable="true"
                :allow-empty="true"
              >
              </multiselect-item>
            </div>
          </div>
          <div class="row">
            <div
              :class="`col-12 form-group form-sm-group${
                !isUbicacionDineroOk && isDirty ? ' invalid' : ''
              }`"
            >
              <label class="typo__label">Ubicación</label>
              <multiselect-item
                v-model="ubicacion"
                :loading="isUbicacionDineroLoading"
                deselect-label="Deseleccionar"
                track-by="id_ubicacion_dinero"
                label="ubicacion_dinero"
                placeholder="Seleccionar Ubicación"
                :options="ubicacionMovimiento"
                :searchable="true"
                :allow-empty="false"
              >
              </multiselect-item>
            </div>
          </div>
          <div class="row">
            <div class="col-12 form-group form-sm-group">
              <label for="anotaciones">Anotaciones</label>
              <textarea
                v-model="anotaciones"
                class="form-control"
                id="anotaciones"
                rows="3"
              >
              </textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <button
                  @click="cancelarModal"
                  type="button"
                  class="btn btn-secondary"
                >
                  Cancelar
                </button>
                <button type="submit" class="btn btn-primary">Aceptar</button>
              </div>
            </div>
          </div>
        </div>
      </card-item>
    </form>
  </b-modal>
</template>

<script>
import { get } from "lodash-es";
import { convertDateToString, dateForInput } from "../../../lib/utils/dates";
import axios from "axios";
import vueNumeric from "../../../lib/utils/vue-numeric.vue";

export default {
  name: "CrearMovimiento",
  data() {
    return {
      fecha: "",
      monto: 0,
      moneda: "Pesos",
      anotaciones: "",
      movimientoConcepto: null,
      movimientoConceptoItem: null,
      ubicacion: null,
      isUbicacionDineroLoading: true,
      isMovimientoConceptoLoading: true,

      isDirty: false,
    };
  },
  props: {
    tipoMovimiento: {
      type: String,
      default: "Ingreso",
    },
  },
  components: { vueNumeric },
  methods: {
    async submit() {
      this.isDirty = true;
      if (this.isFechaOk && this.isMontoOk && this.isUbicacionDineroOk) {
        const formData = {
          fecha: convertDateToString(this.fecha),
          ingreso: this.tipoMovimiento === "Ingreso" ? this.monto : 0,
          egreso: this.tipoMovimiento === "Egreso" ? this.monto : 0,
          moneda: this.moneda,
          id_movim_concepto: get(
            this.movimientoConcepto,
            "id_movim_concepto",
            null,
          ),
          id_movim_concepto_items: get(
            this.movimientoConceptoItem,
            "id_movim_concepto_items",
            null,
          ),
          id_ubicacion_dinero: this.ubicacion.id_ubicacion_dinero,
          anotaciones: this.anotaciones,
        };
        const resp = await axios.post("/movimientos", formData);

        if (resp.data.ok) {
          this.$bvModal.hide("crearMovimientoModal");
          this.$emit("movimiento-creado");
          this.$bvToast.toast(resp.data.message, {
            variant: "success",
          });
        } else {
          this.$bvToast.toast(resp.data.message, {
            variant: "danger",
          });
        }
      } else {
        this.$msgBoxOk("algo anda mal");
      }
    },
    cancelarModal() {
      this.$bvModal.hide("crearMovimientoModal");
      this.borrarMovimiento;
    },
    borrarMovimiento() {
      this.fecha = "";
      this.monto = 0;
      this.moneda = "Pesos";
      this.anotaciones = "";
      this.movimientoConcepto = null;
      this.movimientoConceptoItem = null;
      this.ubicacion = null;
      this.isUbicacionDineroLoading = true;
      this.isMovimientoConceptoLoading = true;
      this.isDirty = false;
    },
    mostrarMovimiento() {
      this.fecha = dateForInput(new Date());

      this.isUbicacionDineroLoading = true;
      this.isMovimientoConceptoLoading = true;
      this.$store.dispatch("Movimientos/getMovimientoConceptos").then(() => {
        this.isMovimientoConceptoLoading = false;
      });
      this.$store.dispatch("ubicacionDinero/getUbicaciones").then(() => {
        this.isUbicacionDineroLoading = false;
      });
    },
  },
  computed: {
    isFechaOk() {
      return this.fecha !== "";
    },
    isMontoOk() {
      return this.monto !== 0 && parseFloat(this.monto) > 0;
    },
    isUbicacionDineroOk() {
      return this.ubicacion !== null;
    },
    movimientoConceptos() {
      return this.$store.getters["Movimientos/getMovimientoConceptos"];
    },
    ubicacionMovimiento() {
      return this.$store.getters["ubicacionDinero/getUbicaciones"];
    },
  },
};
</script>

<style>
.invalid .multiselect__tags {
  border-color: red;
}
</style>
